import { useSelector } from 'react-redux'

import { Tooltip } from '@chakra-ui/react'

import { DragEventI, Draggable } from '@/components/ui'
import { CheckpointIProps } from '@/features/floor-plan'
import { selectMe } from '@/redux/me/meSlice'
import { mixpanel } from '@/utils/analytics'

import { CheckpointListItem } from './CheckpointListItem'

export interface UnPlacedCheckpointListItemIProps {
  checkpoint: CheckpointIProps
  isEditMode: boolean
  onTileDragStart: (event: DragEventI) => void
  onClick: (checkpoint: CheckpointIProps) => void
}

export const UnPlacedCheckpointListItem = ({
  checkpoint,
  isEditMode,
  onTileDragStart,
  onClick,
}: UnPlacedCheckpointListItemIProps) => {
  const me = useSelector(selectMe)

  return (
    <Tooltip
      isDisabled={!isEditMode}
      label='Drag checkpoint to the map to place'
      shouldWrapChildren
    >
      <Draggable
        dragData={checkpoint}
        dragEnabled={isEditMode}
        key={checkpoint.id}
        onDragEnded={() => {
          mixpanel.track('Button Press: Map Checkpoint - End Moving', {
            checkpoint_id: checkpoint.id,
            facility_id: checkpoint.facility.id,
            floor_id: checkpoint.floor.id,
            role: me.roleName,
          })
        }}
        onDragStart={(e: DragEventI) => {
          mixpanel.track('Button Press: Map Checkpoint - Move Placement', {
            checkpoint_id: checkpoint.id,
            facility_id: checkpoint.facility.id,
            floor_id: checkpoint.floor.id,
            role: me.roleName,
          })
          onTileDragStart(e)
        }}
      >
        <CheckpointListItem
          id={checkpoint.id}
          isEditMode={isEditMode}
          key={checkpoint.id}
          label={checkpoint.name}
          onClick={() => onClick(checkpoint)}
          placed={checkpoint.isPlaced}
          subLabel={checkpoint.displayId}
        />
      </Draggable>
    </Tooltip>
  )
}
